import React from 'react';
import { useNavigate } from 'react-router-dom';

const OnboardingPage = () => {
  const navigate = useNavigate();

  const handleEnter = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Hero section */}
      <div className="flex-grow flex flex-col items-center justify-center px-4 py-16 sm:px-6 lg:px-8">
        <div className="max-w-4xl w-full space-y-12 text-center">
          {/* Logo and branding */}
          <div className="flex flex-col items-center">
            <div className="mb-8">
              {/* Motiv8 Equals Logo with Gradient */}
              <svg width="100" height="100" viewBox="0 0 160 160" className="mb-2">
                <defs>
                  <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#FF0099" />
                    <stop offset="50%" stopColor="#FF2468" />
                    <stop offset="100%" stopColor="#FF6D33" />
                  </linearGradient>
                </defs>
                <rect width="160" height="160" fill="url(#logoGradient)" />
                <rect x="40" y="50" width="80" height="20" fill="white" />
                <rect x="40" y="90" width="80" height="20" fill="white" />
              </svg>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight">
              AWS EC2 <span className="text-[#FF2468]">Controller</span>
            </h1>
            <p className="mt-6 text-xl md:text-2xl text-gray-600 max-w-3xl">
              Efficiently manage your cloud infrastructure with our intuitive dashboard
            </p>
          </div>
          
          {/* Features section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 text-left">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#FF2468]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Instant Control</h3>
              <p className="mt-2 text-gray-600">Start and stop your EC2 instances with just a single click</p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#FF2468]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Secure Access</h3>
              <p className="mt-2 text-gray-600">Authenticated with Microsoft Azure AD for enterprise-grade security</p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#FF2468]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Real-time Monitoring</h3>
              <p className="mt-2 text-gray-600">View the status of your instances in real-time</p>
            </div>
          </div>
          
          {/* CTA Button */}
          <div className="mt-12">
            <button
              onClick={handleEnter}
              className="px-8 py-4 bg-gradient-to-r from-[#FF0099] via-[#FF2468] to-[#FF6D33] text-white text-lg font-medium rounded-md shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2 transition-all duration-300"
            >
              Get Started
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 inline-block" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="bg-white py-6 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-sm text-gray-500">
                &copy; {new Date().getFullYear()} Motiv8AI. All rights reserved.
              </p>
            </div>
            <div className="flex space-x-6">
              <a href="https://motiv8ai.io/privacy" className="text-gray-400 hover:text-gray-500">
                <span className="sr-only">Privacy</span>
                Privacy Policy
              </a>
              <a href="https://motiv8ai.io/terms" className="text-gray-400 hover:text-gray-500">
                <span className="sr-only">Terms</span>
                Terms of Service
              </a>
              <a href="https://motiv8ai.io/contact" className="text-gray-400 hover:text-gray-500">
                <span className="sr-only">Contact</span>
                Contact
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OnboardingPage; 